import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { TrackframeHeader } from '@verybigthings/trackframe-hub-client/ui/components/header';
import { hubBaseUrl } from '@/lib/hub-client';

// Chrome for the hub root page (track list). Same shared header as the admin
// shell and every track frontend, but without the admin sidebar. The header's
// one menu already carries the user's own pages (/me/*, ADM-11) and the
// cross-app links (HUB-125), so nothing is added here.
export function HubLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-background text-foreground">
      <TrackframeHeader hubBaseUrl={hubBaseUrl} onLogoClick={() => navigate('/')} />
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}
